import { create } from "zustand";

export const DELETE_STEPS = ["notice", "reason", "confirm", "done"] as const;
export type DeleteStep = (typeof DELETE_STEPS)[number];
export const isDeleteStep = (v: string | undefined): v is DeleteStep => (DELETE_STEPS as readonly string[]).includes(v ?? "");

type DeleteFlowState = {
  /** 도달한 최대 단계. 메모리 전용 — 새로고침하면 notice부터(1.20 step 가드). */
  reached: DeleteStep;
  reason: string | null;
  detail: string;
  /** 탈퇴 직전 회원번호. 세션이 비워진 뒤 done 화면에서 문의용으로 보여 준다(AC0-96). */
  publicId: string | null;
  advance: (to: DeleteStep) => void;
  setReason: (reason: string | null, detail: string) => void;
  setPublicId: (publicId: string | null) => void;
  reset: () => void;
};

export const useDeleteFlow = create<DeleteFlowState>()((set) => ({
  reached: "notice",
  reason: null,
  detail: "",
  publicId: null,
  advance: (to) => set((s) => (DELETE_STEPS.indexOf(to) > DELETE_STEPS.indexOf(s.reached) ? { reached: to } : s)),
  setReason: (reason, detail) => set({ reason, detail }),
  setPublicId: (publicId) => set({ publicId }),
  reset: () => set({ reached: "notice", reason: null, detail: "", publicId: null }),
}));

/** step이 도달 단계보다 앞서면 순서 건너뛰기 → 돌아갈 단계를 돌려준다. */
export function guardStep(step: DeleteStep, reached: DeleteStep): DeleteStep | null {
  return DELETE_STEPS.indexOf(step) > DELETE_STEPS.indexOf(reached) ? "notice" : null;
}
